module.exports = __webpack_public_path__ + "img/beneficiaries.c955ec6b.svg";